import PropTypes from 'prop-types';
import React from 'react';
import { Popover, OverlayTrigger } from 'react-bootstrap';
import IncentiveLink from './IncentiveLink';
import { CONDITIONAL_SPECIAL_DESCRIPTION } from '../constants/constants';

class IncentiveDetail extends React.Component {
	render() {
		const {
			incentives,
			labels,
			heading,
			headingInfo,
			footnoteConditional,
			isMobile,
			showModal
		} = this.props;
		let incentivesList = null;

		if (incentives.length) {
			const body = incentives.map(incentive => {
				const { key } = incentive;
				return (
					<IncentiveLink
						key={key}
						incentive={incentive}
						showModal={showModal}
						showFootnote={
							footnoteConditional && incentive.conditional
						}
					/>
				);
			});

			// Add heading and tooltip if needed
			let listHeading;
			let headingTooltip;
			if (heading) {
				if (headingInfo) {
					const popoverPlacement = isMobile ? 'top' : 'left';
					const popoverHoverFocus = (
						<Popover id="incentive-detail-popover">
							{labels.get(CONDITIONAL_SPECIAL_DESCRIPTION)}
						</Popover>
					);

					headingTooltip = (
						<OverlayTrigger
							trigger={['hover', 'focus']}
							placement={popoverPlacement}
							overlay={popoverHoverFocus}
						>
							<span>
								<i className="ddc-icon ddc-icon-info text-muted d-inline-block pl-1" />
							</span>
						</OverlayTrigger>
					);
				}

				listHeading = (
					<h5 className="pt-3">
						{heading}
						{headingTooltip}
					</h5>
				);
			}
			incentivesList = (
				<div>
					{listHeading}
					<ul className="list-unstyled line-height-condensed mb-0">
						{body}
					</ul>
				</div>
			);
		}
		return incentivesList;
	}
}

IncentiveDetail.propTypes = {
	incentives: PropTypes.arrayOf(
		PropTypes.shape({
			key: PropTypes.string,
			title: PropTypes.string,
			label: PropTypes.string,
			offerDetails: PropTypes.string,
			shortTitle: PropTypes.string,
			disclaimer: PropTypes.string,
			effectiveDate: PropTypes.string,
			expirationDate: PropTypes.string,
			conditional: PropTypes.bool,
			manufacturerOffer: PropTypes.bool
		}).isRequired
	).isRequired,
	labels: PropTypes.shape({
		get: PropTypes.func
	}).isRequired,
	heading: PropTypes.string,
	headingInfo: PropTypes.string,
	showModal: PropTypes.func.isRequired,
	footnoteConditional: PropTypes.bool,
	isMobile: PropTypes.bool.isRequired
};

IncentiveDetail.defaultProps = {
	heading: '',
	headingInfo: '',
	footnoteConditional: false
};

export default IncentiveDetail;



// WEBPACK FOOTER //
// ./src/components/IncentiveDetail.jsx